import React from 'react'

const SearchIcon = () => { 
    return (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="9.47369" cy="9.47369" r="7.47369" stroke="white" strokeWidth="4"/>
            <path d="M21.6386 25.4142C22.4196 26.1952 23.686 26.1952 24.467 25.4142C25.2481 24.6331 25.2481 23.3668 24.467 22.5857L21.6386 25.4142ZM13.1123 16.8878L21.6386 25.4142L24.467 22.5857L15.9407 14.0594L13.1123 16.8878Z" fill="white"/>
            <style jsx>{`
                path, circle {
                    transition: all .3s ease-in-out;
                }
            `}</style>
        </svg>
    )
}

export default SearchIcon